function a(r) {
  let e = r.replace("-", "+").replace("_", "/");
  for (; e.length % 4; )
    e += "=";
  const t = Buffer.from(e, "base64").toString("utf8");
  return JSON.parse(t);
}
export {
  a as default
};
